angular
  .module('ui-ng-calendar-time')
  .controller('CalendarTimeController', function ($scope, $attrs, $timeout, calendarTimeFn, DayOfTheWeekEnum) {
    function filterDayColumns(days, includeWeekends, useMicroname) {
      return _.map(
        _.filter(days, function (day) {
          return (includeWeekends === 'false' && (day.key === 'su' || day.key === 'sa')) || day.key === 'online'
            ? false
            : true;
        }),
        function (day) {
          if (useMicroname === 'true') {
            return {
              id: day.id,
              name: day.value.microname
            };
          }

          return {
            id: day.id,
            name: day.value.shortname
          };
        }
      );
    }

    $scope.padWithZero = function padWithZero(v) {
      return parseInt(v, 10) < 10 ? '0' + v : v;
    };

    $scope.writeTimeFormat = function writeTimeFormat(hours, minutes) {
      return $scope.padWithZero(hours) + ':' + $scope.padWithZero(minutes) + ':00';
    };

    $scope.flags = {
      includeCalendar: true,
      includeList: true,
      includeInstructions: true
    };

    $scope.colors = ['#3381b0'];

    $scope.enums = {
      dayOfTheWeek: DayOfTheWeekEnum,
      allDays: _.filter(DayOfTheWeekEnum.iterator(), function (day) {
        return !DayOfTheWeekEnum.isEqual(day, DayOfTheWeekEnum.ONLINE);
      }),
      days: filterDayColumns(_.toArray(DayOfTheWeekEnum.iterator()), $scope.includeWeekends, $scope.microheaders)
    };

    $scope.specification = {
      hourStep: parseInt($scope.hourStep || 1, 10),
      hourBegin: parseInt($scope.hourBegin || 8, 10),
      hourEnd: parseInt($scope.hourEnd || 22, 10),
      colorIndex: 0
    };

    $scope.specification.firstHour = $scope.writeTimeFormat($scope.specification.hourBegin, 0);
    $scope.specification.lastHour = $scope.writeTimeFormat($scope.specification.hourEnd, 0);

    $scope.isCalendarEmpty = function isCalendarEmpty() {
      return _.isEmpty($scope.times);
    };

    $scope.eraseTime = function eraseTime(time) {
      // NOTE times updated
      _.remove($scope.times, time);
      $scope.whenUpdated({ times: $scope.times });
    };

    $scope.addEmptyTime = function addEmptyTime() {
      $scope.times = calendarTimeFn.addEmptyTimeOfDay(
        $scope.times,
        $scope.specification.firstHour,
        $scope.specification.lastHour
      );
      $scope.whenUpdated({ times: $scope.times });
      $timeout(function () {
        $element.find('tr.mrm-children').last().find('td > *').first().focus();
      }, 0);
    };

    $scope.addEmptyTimeByKey = function (event) {
      if (event && event.which === 13) {
        $scope.addEmptyTime();
      }
    };

    // manage time collapse

    $scope.alignTimesColumnLeft = function alignTimesColumnLeft(alignTimes) {
      return alignTimes === 'left' || alignTimes === 'both';
    };

    $scope.alignTimesColumnRight = function alignTimesColumnRight(alignTimes) {
      return alignTimes === 'right' || alignTimes === 'both';
    };

    $scope.collapseOnce = true;
    $scope.collapseTime = function collapseTime(times, forceCollapse) {
      $scope.collapseOnce = !_.isUndefined(forceCollapse) ? true : $scope.collapseOnce;

      if (!$scope.collapseOnce) {
        return;
      }

      $scope.times = calendarTimeFn.collapseTimes($scope.times);
      $scope.whenUpdated({ times: $scope.times });
      $scope.collapseOnce = false;
    };

    $scope.collapseTimeByKey = function collapseTimeByKey(event, times, forceCollapse) {
      if (event && event.which === 13) {
        $scope.collapseTime(times, forceCollapse);
      }
    };

    var removeTimesWatch = $scope.$watch('times', function () {
      if (($attrs.autoCollapse === '' || $attrs.autoCollapse === 'true') && _.size($scope.times) > 0) {
        // NOTE times updated
        $scope.times = calendarTimeFn.collapseTimes($scope.times);
        removeTimesWatch();
      }
    });
  })
  .factory('calendarTimeDelegateConfiguration', function (calendarTimeFn) {
    return {
      uniqueComponent: 'calendar-time',
      vocabulary: {
        cleanup: function (scope, element, attrs, event, times) {
          scope.$applyAsync(function () {
            // NOTE times updated
            scope.times = calendarTimeFn.collapseTimes(times || scope.times);
          });
        }
      }
    };
  })
  .directive('calendarTime', function calendarWeek(DelegateResponder, calendarTimeDelegateConfiguration) {
    'use strict';

    return {
      restrict: 'E',
      replace: false,
      scope: {
        times: '=',
        includeCalendar: '@',
        includeList: '@',
        readOnly: '@',
        autoCollapse: '@',
        includeInstructions: '@',
        hourEnd: '@',
        hourStep: '@',
        hourBegin: '@',
        emptyMessage: '@',
        whenUpdated: '&',
        includeWeekends: '@',
        microheaders: '@',
        alignTimes: '@',
        onSelected: '&'
      },
      controller: 'CalendarTimeController',
      templateUrl: 'ui-ng-calendar-time/src/view/calendar_time.html',
      compile: function (element, attrs) {
        element.addClass('calendar-time');

        return DelegateResponder(calendarTimeDelegateConfiguration, function (scope, element, attrs) {
          var assignInteractionMode = function assignInteractionMode() {
            if (attrs.readOnly === '' || attrs.readOnly === 'true' || attrs.readOnly === 'readOnly') {
              scope.readOnly = true;
              element.addClass('read-only');
            } else {
              scope.readOnly = false;
              element.removeClass('read-only');
            }
          };

          attrs.$observe('readOnly', assignInteractionMode);
          assignInteractionMode();

          attrs.$observe('includeList', function (v) {
            scope.flags.includeList = v === '' || v === 'true' || v === 'includeList';
          });

          attrs.$observe('includeCalendar', function (v) {
            scope.flags.includeCalendar = v === '' || v === 'true' || v === 'includeCalendar';
          });

          attrs.$observe('includeInstructions', function (v) {
            scope.flags.includeInstructions = v === '' || v === 'true' || v === 'includeInstructions';
          });
        });
      }
    };
  })
  .service('calendarTimeDelegate', function lightBulbDelegate(DelegateController, calendarTimeDelegateConfiguration) {
    DelegateController(this, calendarTimeDelegateConfiguration);
  });



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar-time/src/view/calendar_time.js